Vue.asyncComponent('cms-dashboard-title', {
    props: {
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        headingLevel: {
            type: String,
            default: 'h2',
        },
        alignment: {
            type: String,
            default: 'left',
        },
    },
    computed: {
        /**
         * Normalize the configured heading level.
         */
        normalizedHeadingLevel() {
            return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(this.headingLevel)
                ? this.headingLevel
                : 'h2';
        },
        /**
         * Title alignment class.
         */
        titleAlignmentClass() {
            return `cms-dashboard-title--align-${this.alignment || 'left'}`;
        },
    },
}, 'cms/dashboard/live/cms-dashboard-title.html');
